<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/dhbanner.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>鼎和1-6类团意险</h2>
					<div>高性价比 | 鼎和财产保险股份有限公司承保 | 全线上操作</div>
					<p>
						① 1-6类工种覆盖广
						<br />
						② 可单独加费扩展猝死保障
						<br />
						③ 社保用药、住院津贴双保障
						<br />
						④ 5人起保，5-6类最高可选60万
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载鼎和职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud ref="crud" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan">
						<template slot="header">
							<el-radio-group v-model="currentIndex" style="margin-bottom: 10px" @change="onChangeFee">
								<el-radio-button label="年保费">年保费</el-radio-button>
								<el-radio-button label="6月保费">6月保费</el-radio-button>
								<el-radio-button label="3月保费">3月保费</el-radio-button>
								<el-radio-button label="1月保费">1月保费</el-radio-button>
							</el-radio-group>
						</template>
					</avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							社保用药范围100%赔付，免赔100元,伤残等级对应赔付比例请查看附表
						</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit"></avue-crud>
				</el-card>
				<el-descriptions :column="1" border style="margin-bottom: 30px" title="注意事项">
					<el-descriptions-item label="起保人数">
						一份保单须投保
						<span style="color: red">5人以上</span>
					</el-descriptions-item>
				</el-descriptions>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="24">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span v-html="qa.answer"></span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="24">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							1. 本保险适用以下保险条款
							<br />
							2、本保险由鼎和财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。
							<br />
							3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：
							4、保险公司全国统一的客户服务及投诉方式详见如下链接：
							5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
							<br />
							7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							8、本保险根据投保单位的需求提供电子发票或纸质专票。
							<br />
							9、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							<br />
							10、保险责任开始后，投保人要求解除保险合同的，保险人按日比例计算保险费，扣除未满期保费对应的手续费，退还未满期保险费与扣除手续费的差额部分。
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>
						<p style="line-height: 32px">
							1、被保险人雇员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
							<br />
							2、 猝死为可选项，猝死保额为身故保额的50%。
							<br />
							3、在社保报销范围内的医疗费用每人每次免赔人民币100.00元后按照100.00%比例赔付。
							<br />
							4、 意外伤害住院补贴为100.00元/人/天，免赔天数0天，每次事故最多赔偿不超90天，累计赔付以180天为限。
							<br />
							5、被保险人因遭受意外伤害，伤残赔付标准按保险合同所附《人身保险伤残评定标准》（行业标准）对伤残项目进行评定，伤残等级十至一级给付比例：十级10%，九级20%，八级30%，七级40%，六级50%，五级60%，四级70%，三级80%，二级90%，一级100%。
							<br />
							6、被保险人必须按实际从事行业及职业投保，如在出险时被保险人实际从事的职业分类等级高于保单列明承保的职业分类等级，保险公司不承担保险责任。
							<br />
							7、
							被保险人从事特种作业时，未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任。特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。
							<br />
							8、被保险人年龄为16-65周岁，16周岁（含）至18周岁（不含）未成年人意外伤害身故保险责任最高保额 50万元。
							<br />
							9、本保单指定医院范围为：中华人民共和国境内（不包括香港、澳门、台湾地区）二级以上（含二级）公立医院或保险人认可的其他医疗机构，但不包括以下地区的医疗机构：北京市平谷区、密云县、怀柔区所有医疗机构，辽宁省铁岭市所有医疗机构，河北省三河市、青龙县、廊坊市所有医疗机构，山东省禹城市所有医疗机构，河南省信阳市所有医疗机构，四川省宜宾市的所有医疗机构、四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、天津滨海区、静海区所有医疗机构，即上述地区医疗机构的发票保险人不予理赔。事发后因伤势情况危急需第一时间急救抢救的可以放宽至一级公立医院。经抢救伤势情况稳定的需及时转入公立二级以上医院做后续治疗。
							<br />
							10、被保险人从事高处作业时因未系绑安全带导致的保险事故属除外责任。高处作业以《高处作业分级标准》（GB3608-2008）中的定义为准。
							<br />
							11、包含以下关键字的单位不适用此方案：“拆、疏浚、危险品、石油、电梯、铁塔”。
							<br />
							12、投保人、被保险人或者保险金受益人知道意外伤害保险事故发生后，应当在48小时内及时通知保险人。
							<br />
							13、保险责任开始后，投保人要求解除保险合同的，保险人按日比例计算保险费，扣除未满期保费对应的手续费，退还未满期保险费与扣除手续费的差额部分。
							<br />
							14、发生保单项下的死亡保险事故时，对于死因不明的案件，索赔方需要提供尸检报告给保险公司。
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {optionBenefit, optionPlanTy, optionPremium} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product45Details',
	data: function () {
		return {
			currentIndex: '年保费',
			currentStep: '0',
			optionPlan: optionPlanTy,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			feeType: ['（1-2类）', '（3-4类）', '（5类）', '（6类）'],
			customFee: [
				{
					insuredItem: '（1-2类）',
					plan1: 90,
					plan2: 160,
					plan3: 230,
					plan4: 290,
					plan5: 360,
					plan6: 420,
					plan7: 480,
					plan8: 550,
					plan9: 620,
					plan10: 690,
				},
				{
					insuredItem: '（3-4类）',
					plan1: 180,
					plan2: 310,
					plan3: 450,
					plan4: 580,
					plan5: 720,
					plan6: 850,
					plan7: 980,
					plan8: 1200,
					plan9: 1380,
					plan10: 1580,
				},
				{
					insuredItem: '（5类）',
					plan1: 270,
					plan2: 490,
					plan3: 710,
					plan4: 920,
					plan5: 1150,
					plan6: 1380,
					plan7: '/',
					plan8: '/',
					plan9: '/',
					plan10: '/',
				},
				{
					insuredItem: '（6类）',
					plan1: 360,
					plan2: 580,
					plan3: 790,
					plan4: 1020,
					plan5: 1250,
					plan6: 1500,
					plan7: '/',
					plan8: '/',
					plan9: '/',
					plan10: '/',
				},
			],
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '10万',
					plan2: '20万',
					plan3: '30万',
					plan4: '40万',
					plan5: '50万',
					plan6: '60万',
					plan7: '70万',
					plan8: '80万',
					plan9: '90万',
					plan10: '100万',
				},
				{
					insuredItem: '医疗费用',
					plan1: '1万',
					plan2: '2万',
					plan3: '3万',
					plan4: '4万',
					plan5: '5万',
					plan6: '6万',
					plan7: '7万',
					plan8: '8万',
					plan9: '9万',
					plan10: '10万',
				},
				{
					insuredItem: '免赔额',
					plan1: '每次事故免赔100元后，社保用药100%赔付',
				},
				{
					insuredItem: '住院津贴',
					plan1: '100元/天 ，每次不超过90天，累计不超过180天',
				},
				{
					insuredItem: '年保费（1-2类）',
				},
				{
					insuredItem: '年保费（3-4类）',
				},
				{
					insuredItem: '年保费（5类）',
				},
				{
					insuredItem: '年保费（6类）',
				},
				{
					insuredItem: '可选保障项目',
					plan1: '按职业类别对应方案保费的10%，单独加费收取',
				},
				{
					insuredItem: '猝死保额',
					plan1: '5万',
					plan2: '10万',
					plan3: '15万',
					plan4: '20万',
					plan5: '25万',
					plan6: '30万',
					plan7: '35万',
					plan8: '40万',
					plan9: '45万',
					plan10: '50万',
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '10%',
					level9: '20%',
					level8: '30%',
					level7: '40%',
					level6: '50%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer:
						'本产品由鼎和财产保险股份有限公司承保。经营区域：广东、广西、云南、贵州、海南、深圳、四川、上海、湖北、河南、江西、陕西、山东、河北、安徽。',
				},
				{
					question: '团体意外险的保障范围包括哪些？',
					answer:
						'保险责任成立基于2个前提，第一是被保险人遭受保单约定的意外伤害，第二是事故发生在保险期间内。保障范围包括：<br/>1、如果被保险人死亡或残疾承担给付保险金责任，对被保险人未遭受外来伤害，而是由于自身身体原因（包括但不限于：猝死、心脏骤停、呼吸衰竭、急性病突发等排除外来伤害的原因）导致的死亡或残疾不负责赔偿。<br/>2、被保险人在二级或二级以上公立医院，或保险人认可的其他医疗机构接受治疗，保险人按社保标准赔付医疗费用（即自费部分不赔）。<br/>3、如果被保险人根据伤情需要住院，保险人按保单约定支付住院津贴。<br/>4、本保单可单独加费扩展猝死保障。',
				},
				{
					question: '意外的定义是什么？',
					answer: '意外伤害：指以外来的、突发的、非本意的和非疾病的客观事件为直接且单独的原因致使身体受到的伤害。',
				},
				{
					question: '被保险人是否有人数、年龄限制？',
					answer: '本产品5人及以上起保，被保险人年龄为16-65周岁，限投1份。',
				},
				{
					question: '如果投保，无对应职业可选择，应如何处理？',
					answer: '请咨询平台工作人员，由专业客服为您解答。否则，保险人可能拒保。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→支付保费→获取保单。目前支持微信、支付宝、银联支付。',
				},
				{
					question: '保单和发票怎么获取？',
					answer: '线上投保完成后实时出具电子保单，普票则实时出具电子普票',
				},
				{
					question: '保单如何查验真伪？',
					answer: '可以通过拨打鼎和财险全国客服电话95393进行人工查询。',
				},
				{
					question: '被保险人可以替换吗？',
					answer:
						'本产品不支持批减被保险人、变更保额。在保险有效期内，被替换的被保险人在无出险的前提下，可进行不涉及加费的替换。',
				},
				{
					question: '怎么理赔？',
					answer: '出险后请拨打理赔专线95393报案→收集资料→提交审核→支付赔款、结案。',
				},
				{
					question: '什么是高空作业？',
					answer:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。',
				},
				{
					question: '被保险人从事高处作业时因未系绑安全带导致的保险事故，保险公司是否承担保险责任？',
					answer: '保险公司不承担保险责任。',
				},
				{
					question: '被保险人未取得对应的特种作业证书，进行特种作业操作引起的意外事故，保险公司是否承担保险责任？',
					answer: '保险公司不承担保险责任。特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。',
				},
				{
					question: '本保单是否有拒保医院？',
					answer:
						'有。本保单指定医院范围为：中华人民共和国境内（不包括香港、澳门、台湾地区）二级以上（含二级）公立医院或保险人认可的其他医疗机构，但不包括以下地区的医疗机构：北京市平谷区、密云县、怀柔区所有医疗机构，辽宁省铁岭市所有医疗机构，河北省三河市、青龙县、廊坊市所有医疗机构，山东省禹城市所有医疗机构，河南省信阳市所有医疗机构，四川省宜宾市的所有医疗机构、四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、天津滨海区、静海区所有医疗机构，即上述地区医疗机构的发票保险人不予理赔。事发后因伤势情况危急需第一时间急救抢救的可以放宽至一级公立医院。经抢救伤势情况稳定的需及时转入公立二级以上医院做后续治疗。',
				},
			],
		}
	},
	mounted() {
		this.onChangeFee('年保费')
	},
	methods: {
		onChangeFee(index) {
			this.currentIndex = index

			let tempFeeRate = 1
			switch (index) {
				case '6月保费':
					tempFeeRate = 0.7
					break
				case '3月保费':
					tempFeeRate = 0.4
					break
				case '1月保费':
					tempFeeRate = 0.2
			}
			this.dataPlan.forEach((itemData) => {
				let result = this.customFee.find(({insuredItem}) => {
					return itemData.insuredItem.includes(insuredItem)
				})
				if (!this.validatenull(result)) {
					itemData.insuredItem = this.currentIndex + result.insuredItem
					//计算保费
					for (let i = 1; i <= 10; i++) {
						let temp = result['plan' + i]
						itemData['plan' + i] = temp !== '/' ? (temp * tempFeeRate).toFixed(0) + '元' : temp
					}
				}
			})
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 3 || rowIndex === 8) {
				if (columnIndex === 1) {
					return [1, 11]
				}
			}
		},
		spanMethodPremium({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 11]
				}
			}
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			window.open(`https://file.meibaokeji.com/admin_process/profession_category/template_edhic_profession.xlsx?v=83`)
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .avue-crud__menu {
	min-height: 0 !important;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
